var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4775 0C10.0575 0 0 10.08 0 22.5C0 34.92 10.0575 45 22.4775 45C34.92 45 45 34.92 45 22.5C45 10.08 34.92 0 22.4775 0ZM22.5 40.5C12.555 40.5 4.5 32.445 4.5 22.5C4.5 12.555 12.555 4.5 22.5 4.5C32.445 4.5 40.5 12.555 40.5 22.5C40.5 32.445 32.445 40.5 22.5 40.5ZM23.625 11.25H20.25V24.75L32.0625 31.8375L33.75 29.07L23.625 23.0625V11.25Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTime);
export default __webpack_public_path__ + "static/media/total-time.3ad498596aa90056603cd0fad4264bc1.svg";
export { ForwardRef as ReactComponent };